import * as path from 'path';

export function isRunningInElectron(): boolean {
  // Renderer process
  if (typeof window !== 'undefined' &&
    // tslint:disable-next-line:no-any
    typeof (window as any).process === 'object' &&
    // tslint:disable-next-line:no-any
    (window as any).process.type === 'renderer') {
    return true;
  }

  // Main process
  if (typeof process !== 'undefined' &&
    typeof process.versions === 'object' &&
    // tslint:disable-next-line:no-any
    !!(process.versions as any).electron) {
    return true;
  }

  // Detect the user agent when the `nodeIntegration` option is set to true
  if (typeof navigator === 'object' &&
    typeof navigator.userAgent === 'string' &&
    navigator.userAgent.indexOf('Electron') >= 0) {
    return true;
  }
  return false;
}

export function dataDirectory(): string {
    // tslint:disable-next-line:no-any
    let dataDir = (window as any).DATA_DIR;
    if (dataDir === undefined || dataDir === null) {
      dataDir = './';
    }
    return path.join(dataDir, 'data');
}


// WEBPACK FOOTER //
// ./~/tslint-loader!./src/utils/common.ts